module.exports = __webpack_public_path__ + "img/ffadfs.6866a260.png";